import {
  getList,
  getprojectList,
  getGroupList,
  getDictData,
  lazyAreaTree,
  getOrderWorkStatusSum,
  getDeptDetailByAreaId,
  getDeptUserListByDeptId,
  getCooperateList,
  getRemarkList,
  getGroupName,
  getDeptTreeByIds,
  getGroupUser,
  urge,
  treeByProjectDeptId,getServiceCommunityList
} from "@/api/gateservice/order/order-list/order-list";
import {
  getDeptNameByUserId
} from "@/api/crmedical/car/car-record/index";
import {
  getOrderUrgentLevel,getProviderList
} from "@/api/gateservice/order/order";
import {
  mapGetters
} from "vuex";
import optionList from "./order-list-option";
import courseCleanKeeping from "./course-cleanKeeping"; //保洁服务
import courseEquipmentInspection from "./course-equipment-inspection"; //设备巡检
import courseEquipmentMaintenance from "./course-equipment-maintenance"; //设备维保服务
import courseUsecar from "./course-usecar"; //用车服务
import courseComplaints from "./course-complaints"; //投诉监督
import courseEscort from "./course-escort"; //陪护服务
import courseRepair from "./course-repair"; //报修服务
import courseRepairInformation from "./course-repair-information"; //报修服务-信息设备维修
import courseRepairLogistics from "./course-repair-logistics"; //报修服务-医疗设备维修
import courseSecurity from "./course-security"; //保安服务
import courseTransport from "./course-transport"; //运送服务
import courseAreaInspection from "./course-area-inspection"; //区域巡检
import courseComprehensiveInspection from "./course-comprehensive-inspection"; //综合巡检
import ImportFile from '@/views/nursingHome/initData/importFile';
import exportDataSimple from "@/components/exportData/exportDataSimple";
import {
  modulesSetting,
  settingPositionflag,
  getDictionary,
  modulesSetting2
} from "@/api/gateservice/order/order-add";
import {
  lazyTree
} from "@/api/crmedical/project/area";
import {
  getSubModuleList,
  getSubModuleListByOrderFlag,
  getServiceItemList,
  createOrder,
  appointOrder,
  grabOrder,
} from "@/api/gateservice/order/order";
// 工单新增模块
import modules from "../order-add/modules";
import modulesConfig from "../order-add/modulesConfig";
// 上传
import VUpload from "@/views/components/v-upload";
import UserEditBox4 from "@/views/components/user-edit-box4";
import remarkModel from "../order-list/remark-model";
import {

  getUserListByDepartmentId,
} from "@/api/crmedical/group/group";
import {
  vLongitude,
  vLatitude
} from "@/util/validate";
import {
  getToken
} from '@/util/auth';
import {
  fieldDetail
} from "@/api/v4ward/ordersetting/setting/selfForm"
const mixin = {
  components: {
    ...modules,
    UserEditBox4,
    exportDataSimple,
    VUpload,
    remarkModel,
    courseCleanKeeping,
    courseEquipmentInspection,
    courseEquipmentMaintenance,
    courseUsecar,
    courseComplaints,
    courseEscort,
    courseRepair,
    courseSecurity,
    courseTransport,
    courseAreaInspection,
    courseComprehensiveInspection,
    courseRepairInformation,
    courseRepairLogistics,
    ImportFile
  },
  data() {
    let option = optionList;

    return {
      isImportDialogShow: false,
      communityList:[],
      satisfactionList:[],
      serviceProviderIdList:[],
      searchDeptTreeData: [],
      deptList_: [],
      evaluateList: [{
          dictKey: 1,
          dictValue: '合格'
        },
        {
          dictKey: 0,
          dictValue: '不合格'
        },
        // {
        //   dictKey:'1',
        //   dictValue:'合格'
        // },

      ],
      useTypeList: [],
      formImgRequireFlag: false,
      timer: null,
      refreshChecked: false,
      dialogBodyHight: 0,
      dialogFull: false,
      pageMode: 1,
      remainUserList: [],
      searchBoxFlag: true,

      exportForm: {},
      exportExcelSelectionRadio: '1',
      exportExcelSelectionBoxFlag: false,
      contractIds: '',

      projectId: '',
      groupSelectDisabled: false,
      crudLoading: false,
      courseCleanKeepingFlag: false,
      courseEquipmentInspectionFlag: false,
      courseEquipmentMaintenanceFlag: false,
      courseUsecarFlag: false,
      courseComplaintsFlag: false,
      courseEscortFlag: false,
      courseRepairFlag: false,
      courseRepairInformationFlag: false,
      courseRepairLogisticsFlag: false,
      courseSecurityFlag: false,
      courseTransportFlag: false,
      courseAreaInspectionFlag: false,
      courseComprehensiveInspectionFlag: false,

      transferOperatorList: [],
      remarkAddFormList: [],
      fileList: [],
      submitLoading: false,
      dialogOrderGrabbingBoxVisible: false,
      dialogOrderPressingBoxVisible: false,
      dialogOrderAppointBoxVisible: false,
      deviceIdReportRepair: "",
      dic: [{
          title: 666,
          key: 5555,
        },
        {},
      ],
      cooperateList: [],
      contactNameList: [],
      advanceSearchFlag: false,
      treeNodeId: "",
      treeProps: {
        //标题
        label: "name",
        //值
        value: "id",
        //子节点
        children: "zones",
        //是否叶子节点
        isLeaf: "hasChildren",
        //本节点类型key值
        objectType: "id",
        //本节点类型名
        objectTypeName: "name",
      },
      treeFormAreaData: [],
      firstDisplayFlag: false,
      courseCleanKeepingShow: false, //展示保洁服务历程弹窗
      courseEquipmentShow: false, //展示设备维保历程弹窗
      projectIdList: [], //项目下拉框
      workStatusList: [], //工单状态
      workStatusList_: [], //工单状态
      workStatusDict: [], //工单状态字典数据
      orderAngleList: [],
      moduleTypeList: [],
      moduleTypeList_: [],
      urgentLevelList: [], //紧急程度
      approveFlagList: [], //审批标识
      timeoutFlagList: [], //超时标识
      form: {},
      query: {},
      reWrite: false,
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: optionList,
      data: [],
      dialogOrderCreateBoxVisible: false,
      orderRequireSourceList: [],
      addForm: {},
      choosenModuleName: "",
      moduleTypeKey: "",

      appointForm: {
        userName_: [],
      },
      orderGrabbingForm: {},
      orderPressingForm: {},
      remarkAppointList: [],
      remarkGrabbingList: [],
      remarkPressingList: [],

      addFormRules: {
        source: [{
          required: true,
          message: "请选择来源",
          trigger: "change"
        }],
        projectId: [{
          required: true,
          message: "请选择项目",
          trigger: "change"
        }, ],
        moduleType: [{
          required: true,
          message: "请选择服务类型",
          trigger: "change"
        }, ],
        serviceItemId: [{
          required: true,
          message: "请选择服务项目",
          trigger: "change"
        }, ],
        areaId: [{
          required: true,
          message: "请选择服务地点",
          trigger: "change"
        }, ],
        requireMainId: [{
          required: true,
          message: "请选择需求人",
          trigger: "change"
        }, ],
        urgentLevel: [{
          required: true,
          message: "请选择紧急程度",
          trigger: "bulr"
        }, ],
        useType: [{
          required: true,
          message: "请选择用途",
          trigger: "bulr"
        }, ],
        expectStartDate: [{
          required: true,
          message: "请选择期望到场时间",
          trigger: "change"
        }, ],

        communityId: [{
          required: true,
          message: "请选择服务地点",
          trigger: "change"
        }, ],
        contactAddress: [{
          required: true,
          message: "请输入详细地址",
          trigger: "blur"
        }, ],
        contactName: [{
          required: true,
          message: "请输入需求人",
          trigger: "blur"
        }, ],
        contactPhone: [{
          required: true,
          message: "请选择联系电话",
          trigger: "change"
        }, ],
        // description: [{
        //     required: true,
        //     message: "请输入需求描述",
        //     trigger: "change"
        //   },
        //   // { validator: vString("需求描述"), trigger: "change" },
        // ],
        positionLatitude: [{
            required: true,
            message: "请输入纬度",
            trigger: "change"
          },
          {
            validator: vLatitude(),
            trigger: "change"
          },
        ],
        positionLongitude: [{
            required: true,
            message: "请输入经度",
            trigger: "change"
          },
          {
            validator: vLongitude(),
            trigger: "change"
          },
        ],
      },

      addFormExtend: {},

      searchform: {
        projectId:'',
        description:""
      },

      addOrderFormOption: {
        column: [{
            type: "input",
            label: "来源",
            prop: "source",
            span: 8,
            formslot: true,
          },
          {
            type: "select",
            label: "项目名称",
            prop: "projectId",
            formslot: true,
            rules: [{
              required: true,
              message: "请选择项目",
              trigger: "blur"
            }],
            span: 8,
          },
          {
            type: "select",
            label: "服务地点",
            prop: "areaId",
            formslot: true,
            span: 8,
          },
          {
            type: "select",
            label: "需求人",
            prop: "requireMainId",
            span: 8,
            formslot: true
          },

          {
            type: "input",
            label: "服务类型",
            prop: "moduleType",
            span: 8,
            formslot: true,
          },
          // {
          //   type: "input",
          //   label: "子类型",
          //   prop: "subModuleId",
          //   span: 8,
          //   formslot: true,
          // },
          {
            type: "input",
            label: "紧急程度",
            prop: "urgentLevel",
            span: 8,
            formslot: true,
          },
          {
            type: "datetime",
            label: "期望到场时间",
            prop: "expectStartTime",
            span: 8,
          },
          // {

          //   label: "关键词",
          //   prop: "expectStartTime",

          // },
          {
            type: "input",
            label: "需求位置纬度",
            prop: "positionLatitude",
            display: false,
            span: 8,
          },
          {
            type: "input",
            label: "需求位置经度",
            prop: "positionLongitude",
            display: false,
            span: 8,
          },
          {
            type: "input",
            label: "需求人员",
            prop: "contactName",
            span: 8,
            readonly: true,
            display: false,
          },
          {
            type: "textarea",
            label: "需求描述",
            prop: "description",
            span: 24,
          },
          {
            type: "input",
            label: "附件",
            prop: "attachList",
            span: 24,
            formslot: true,
          },
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          const t1 = time.getTime() // 单位为毫秒
          // time是默认00:00:00，会导致当天不可选，添加时间 (加到23:59:59)
          const timeNew = t1 + (24 * 60 * 60 * 1000 - 1)
          return timeNew < Date.now();
        }
      },
      // 日期是否选择
      dateSelected: false,
      activeTimeRange: [],
      // 时间段
      timeRangeList: [
        {
          text: "08:00 - 09:00"
        },
        {
          text: "09:00 - 11:00"
        },
        {
          text: "11:00 - 13:00"
        },
        {
          text: "13:00 - 15:00"
        },
        {
          text: "15:00 - 17:00"
        },
        {
          text: "17:00 - 19:00"
        }
      ]
    };
  },
  //   computed: {
  //     ...mapGetters(["permission"]),
  //     permissionList() {
  //         return {
  //             viewBtn: this.vaildData(this.permission.orderList_view, false),
  //             editBtn: this.vaildData(this.permission.orderList_edit, false)
  //         };
  //     },

  // },
  mounted() {
    // this.$refs.crud.getTableHeight();
    console.log(this.$refs.crud);
    this.dialogFull = false;
    let bodyHight = document.body.clientHeight;

    this.dialogBodyHight = bodyHight - 330;
    setTimeout(() => {
      document.querySelector('.avue-crud__search').style.display = 'none';
      this.$refs.crud.getTableHeight();
    });
  },
  created() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    getDeptTreeByIds().then((res) => {
      this.dic = res.data;
    });
    console.log("this.option===============>",this.option);
    // console.log(123123)
    // getCooperateList().then((res) => {
    //   console.log(res);
    //   this.cooperateList = res.data;
    // });
    getOrderUrgentLevel().then((res) => {
      console.log(res);
      this.urgentLevelList = res.data;
    });
    this.getDictionaryData();
  },
  activated() {
    this.$refs.crud.getTableHeight();
    if (this.$route.query.id) {
      setTimeout(() => {
        this.onLoad_();
      });
    } else {
      setTimeout(() => {
        this.onLoad();
      });
    }
  },
  computed: {
    ...mapGetters(["permission"]),
    ...mapGetters(["userInfo"]),
    permissionList() {
      return {
        viewBtn: this.vaildData(this.permission.orderList_view, false),
        editBtn: this.vaildData(this.permission.orderList_edit, false)
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  watch: {
    "query.projectId"() {
      console.log(123);
    },
    "option.column"() {
      this.$refs.crud.selectClear();
      this.contractIds = "";
    }
  },
  methods: {
    advanceSearchClose(){
      this.advanceSearchFlag = false
    },
    // 切换项目的时候联动部门下拉表数据
    getSearchDeptTreeByIdsAndProjectId(projectId) {
      this.searchform.deptId = "";
      treeByProjectDeptId({
        projectId
      }).then(res => {
        this.searchDeptTreeData = res.data;
      })
    },
    getApp() {
      return {
        month: this.month,
        // 其他需要暴露的属性
      };
    },
    peopleChange(val) {
      console.log("peopleChange");
      if (!val) {

        this.addForm = Object.assign({}, this.addForm, {
          deptId: '',
          requireDeptName: '',
        })
        return;
      }
      this.getDeptNameByUserIdFunc(this.addForm.requireMainId).then((res) => {
        // this.deptList_ = res.data;
        this.addForm.requireDeptName = res.data[0].deptName;
        this.addForm.deptId = res.data[0].deptId;
        this.deptList_ = res.data;
        this.addForm = Object.assign({}, this.addForm, {
          deptId: res.data[0].deptId,
          requireDeptName: res.data[0].deptName
        })
      })
    },
    getDeptNameByUserIdFunc(id) {
      return getDeptNameByUserId({
        id: id
      });
    },
    // 自动刷新列表
    changeRefreshChecked(e) {
      console.log(e)
      this.refreshChecked = e;
      if (this.refreshChecked) {
        this.timer = setInterval(() => {
          this.onLoad();
        }, 60000)
      } else {
        clearInterval(this.timer)
      }
    },
    // 弹窗关闭前
    handleClose(done) {
      let self = this;
      this.$confirm('确认关闭?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {

          self.dialogOrderCreateBoxVisible = false;

        })
        .catch(() => {

        });
    },
    openSearchBox() {
      this.searchBoxFlag = !this.searchBoxFlag;
      this.$nextTick(() => {
        console.log(this.$refs.crud.$refs.table.$el.offsetTop);
        this.$refs.crud.getTableHeight();
      });
    },
    selectionChange(val) {
      console.log(val);
      let Ids = [];
      val.forEach(element => {
        Ids.push(element.id);
      });
      this.contractIds = Ids.join(',');
    },
    //导出合同台账数据
    exportExcel(data) {
      let saveIds = data.exportExcelSelectionRadio == '1' ? '' : this.contractIds;
      if (saveIds.length == 0 && data.exportExcelSelectionRadio == 2) {
        this.$message({
          message: '请选择需要导出的数据！',
          type: 'warning'
        });
        return;
      }
      this.$confirm('是否导出工单数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //导出数据
        let projectId = this.exportForm.projectId;

        if (data.exportExcelSelectionRadio == 2) {
          window.open(
            `/api/v4ward/out/order/orderExport?${
              this.website.tokenHeader
            }=${getToken()}&configExport=${data.configExport}&projectId=${projectId}&saveIds=${saveIds}`
          );
        } else {
          // 将条件参数拼接为路由传参格式
          let paramFormString = this.tool.objToform(this.exportForm);
          //
          window.open(
            `/api/v4ward/out/order/orderExport?${
              this.website.tokenHeader
            }=${getToken()}&configExport=${data.configExport}&${paramFormString}`
          );
        }

      });
    },
    exportExcelSelection() {
      this.exportExcelSelectionBoxFlag = true;
    },
    /* 安康通导出 */
    exportAkTData() {
      this.$confirm('是否导出安康通数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let paramFormString = this.tool.objToform(this.exportForm);
        window.open(
          `/api/v4ward/out/order/exportOutOrder?${
            this.website.tokenHeader
          }=${getToken()}&${paramFormString}`
        );
      });
    },
    /* 安康通导入回调 */
    importAkTDataCB() {
      this.isImportDialogShow = false;
      this.searchReset();
    },
    submitAppointForm() {
      let itemList = [];
      this.appointForm.cooperateList = [];
      this.appointForm.cooperateList = itemList;
      console.log(this.appointForm.cooperateList);
      // return
      if (!this.appointForm.handerId) {
        this.$message.error('请选择"转派人员"!');
        return;
      }
      appointOrder(this.appointForm).then((res) => {
        console.log(res);
        this.dialogOrderAppointBoxVisible = false;
        this.$message.success("操作成功!");
      });
      //派单
    },
    submitOrderGrabbingForm() {
      let itemList = [];
      this.orderGrabbingForm.cooperateList = [];
      this.orderGrabbingForm.cooperateList = this.userMemberList;
      // if (!this.orderGrabbingForm.remark) {
      //   this.$message.error('请填写"备注"!');
      //   return;
      // }
      grabOrder(this.orderGrabbingForm).then((res) => {
        console.log(res);
        this.dialogOrderGrabbingBoxVisible = false;
        this.$message.success("操作成功!");
      });
      //抢单
    },
    orderGrabbingHandler(row) {
      this.remarkGrabbingTemplate = "";
      this.orderGrabbingForm = this.deepClone(row);
      this.orderGrabbingForm.orderId = row.id;
      // getRemarkList({
      //   orderId: row.id,
      //   actionType: 2
      // }).then((res) => {
      //   console.log(res);
      //   this.remarkGrabbingList = res.data;
      // });

      this.dialogOrderGrabbingBoxVisible = true;
      // this.dialogOrderGrabbingBoxVisible = true;
      getGroupName({
        // projectId: row.projectId,
        // moduleType: row.moduleType,
        orderId: row.id,
      }).then((res) => {
        console.log(res);
        this.orderGrabbingForm.groupName = res.data.name;
        this.orderGrabbingForm.groupId = res.data.id;

        // console.log(response);
        this.userMemberList = res.data.userList;

        this.dialogOrderGrabbingBoxVisible = true;
        setTimeout(() => {
          console.log(
            "this.$refs.orderGrabbingFormRemarkModel====>",
            this.$refs.orderGrabbingFormRemarkModel
          );
          console.log("this.$refs.orderGrabbingFormRemarkModel====>", res.data);
          this.$refs.orderGrabbingFormRemarkModel.setRemarkList(
            this.remarkGrabbingList
          );
        });
      });
    },


    submitOrderPressingForm() {
      let itemList = [];
      // this.orderGrabbingForm.cooperateList = [];
      // this.orderGrabbingForm.cooperateList = this.userMemberList;
      // if (!this.orderGrabbingForm.remark) {
      //   this.$message.error('请填写"备注"!');
      //   return;
      // }
      urge(this.orderPressingForm).then((res) => {
        console.log(res);
        this.dialogOrderPressingBoxVisible = false;
        this.$message.success("操作成功!");
      });
      //抢单
    },
    orderPressingHandler(row) {
      this.remarkPressingTemplate = "";
      this.orderPressingForm = this.deepClone(row);
      this.orderPressingForm.orderId = row.id;
      // getRemarkList({
      //   orderId: row.id,
      //   actionType: 2
      // }).then((res) => {
      //   console.log(res);
      //   this.remarkPressingList = res.data;
      //   setTimeout(() => {
      //     console.log(
      //       "this.$refs.orderPressingFormRemarkModel====>",
      //       this.$refs.orderPressingFormRemarkModel
      //     );
      //     console.log("this.$refs.orderPressingFormRemarkModel====>", res.data);
      //     this.$refs.orderPressingFormRemarkModel.setRemarkList(
      //       this.remarkPressingList
      //     );
      //   });
      // });
      this.dialogOrderPressingBoxVisible = true;
      // this.dialogOrderGrabbingBoxVisible = true;
      // getGroupName({
      //   // projectId: row.projectId,
      //   // moduleType: row.moduleType,
      //   orderId: row.id,
      // }).then((res) => {
      //   console.log(res);
      //   this.orderGrabbingForm.groupName = res.data.name;
      //   this.orderGrabbingForm.groupId = res.data.id;

      //   // console.log(response);
      //   this.userMemberList = res.data.userList;

      //   this.dialogOrderGrabbingBoxVisible = true;
      //   setTimeout(() => {
      //     console.log(
      //       "this.$refs.orderGrabbingFormRemarkModel====>",
      //       this.$refs.orderGrabbingFormRemarkModel
      //     );
      //     console.log("this.$refs.orderGrabbingFormRemarkModel====>", res.data);
      //     this.$refs.orderGrabbingFormRemarkModel.setRemarkList(
      //       this.remarkGrabbingList
      //     );
      //   });
      // });
    },

    //服务人员信息拼接
    transferUserList(list) {
      let arrList = list;
      arrList.forEach((ele, index) => {
        arrList[index].realName_ = ele.realName + (ele.phone ? ('(' + ele.phone + ')') : '(无手机号)') + '       ' + '      ' + '      ' + ele.workingCondition + ' ' + ' ' + ' ' + ele.currentCount
      });
      this.transferOperatorList = arrList;
      return arrList;
    },

    //获取班组列表
    loadGroupList(id) {
      const params = {
        orderId: this.orderId
      };
      getGroupList(params).then((res) => {
        console.log("res getGroupList==>", res);
        //A:查到多个班组,通过班组切换获取转办人列表
        if (res.data.length) {
          this.hasGroups = true;
          this.groupList = res.data;
          //B:没查到班组列表(直接通过工单id获取转办人列表)
          getGroupDetails({
            orderId: this.orderId
          }).then((res) => {
            res.data.userList = this.transferUserList(res.data.userList)
            this.complaintForm.group = res.data.name
            // this.$refs.complaintForm.updateDic("handerId", res.data.userList);
          });
        } else {
          this.hasGroups = false;
          // getGroupDetails({ orderId: this.orderId }).then((res) => {
          //   this.$refs.complaintForm.updateDic("handerId", res.data.userList);
          // });
          getGroupDetails({
            orderId: this.orderId
          }).then((res) => {
            res.data.userList = this.transferUserList(res.data.userList)
            this.complaintForm.group = res.data.name
            // this.$refs.complaintForm.updateDic("handerId", res.data.userList);
          });
        }
      });
    },
    // appointGroupChange(val){
    //   console.log('appointGroupChange(val){=========>',val);
    // },
    appointGroupChange(val) {
      console.log('appointGroupChange(val){=========>', val);
      // this.complaintForm.group = val;
      // this.complaintForm.handerId = "";appointForm.handerId

      this.appointForm = Object.assign({}, this.appointForm, {
        handerId: ''
      });
      const params = {
        groupId: val,
        orderId: this.orderId
      };
      getGroupUser(params).then((res) => {
        this.userMemberList = res.data.userList;
        console.log('this.groupList=========>', this.groupList);
        this.groupList.forEach((ele, index) => {
          if (val === ele.groupId) {
            // this.appointForm.groupName = ele.id;
            this.appointForm = Object.assign({}, this.appointForm, {
              groupName: ele.groupName
            });
            console.log('this.appointForm.groupName========>', this.appointForm.groupName);
          }
        });
      });
    },
    appointHandler(row) {
      this.orderId = row.id;
      this.remarkAppointTemplate = "";
      this.appointForm = this.deepClone(row);
      this.appointForm.orderId = row.id;
      this.groupSelectDisabled = false;


      // getRemarkList({
      //   orderId: row.id,
      //   actionType: 1
      // }).then((res) => {
      //   console.log(res);
      //   this.remarkAppointList = res.data;
      // });
      getGroupList({
        orderId: row.id
      }).then((res) => {
        this.groupList = res.data;
        if (res.data.length > 0) {
          this.groupSelectDisabled = false;

          this.appointForm.groupName = res.data[0].groupName;
          const params = {
            groupId: res.data[0].groupId,
            orderId: row.id
          };
          getGroupUser(params).then((res) => {
            this.userMemberList = res.data.userList;
            this.dialogOrderAppointBoxVisible = true;

          });


        } else {
          this.groupSelectDisabled = true;

          getGroupName({
            orderId: row.id,
            // projectId: row.projectId,
            // moduleType: row.moduleType
          }).then((res) => {
            console.log(res);
            this.appointForm.groupName = res.data.name;
            // this.appointForm.groupId = res.data.id;

            this.userMemberList = res.data.userList;
            // getMenberUserList({ groupId: res.data.id }).then((response) => {
            //   console.log(response);
            //   this.userMemberList = response.data;

            // getUserListByDepartmentId({}).then((res) => {
            //   console.log(res);
            // });
            getUserListByDepartmentId({
              groupId: res.data.id
            }).then(
              (response_) => {
                console.log(response_);
                this.userPrincipalList = response_.data;
                this.dialogOrderAppointBoxVisible = true;
                setTimeout(() => {
                  console.log(
                    "this.$refs.appointFormRemarkModel====>",
                    this.$refs.appointFormRemarkModel
                  );
                  console.log("this.$refs.appointFormRemarkModel====>", res.data);
                  this.$refs.appointFormRemarkModel.setRemarkList(
                    this.remarkAppointList
                  );
                });
              }
            );
            // this.dialogOrderAppointBoxVisible = true;
            // });
          });
        }
      })
    },
    changeRequireUserHandler_(val) {
      let tempRequiredUserName = "";
      this.requireUserList.forEach((ele, index) => {
        if (val === ele.id) {
          tempRequiredUserName = ele.realName;
        }
      });
      this.addForm = Object.assign({}, this.addForm, {
        contactName: tempRequiredUserName,
      });
      console.log("this.addForm=====>", this.addForm);
    },
    // 新增工单
    submitOrderCreateForm() {
      this.submitLoading = true;
      console.log("this.addForm=======>", this.addForm);
      if (this.formImgRequireFlag) {
        if (this.fileList.length == 0) {
          this.$message.error("附件上传不能为空");
          this.submitLoading = false;
          return
        }
      }
      if (this.subModuleList && JSON.stringify(this.subModuleList) === "{}") {

      } else if (!this.subModuleList) {

      } else {
        // if (!this.addForm.subModuleId) {
        //   this.$message.error("请选择'子类型名称'!");
        //   this.submitLoading = false;
        //   return;
        // }
      }

      this.$refs.addForm.validate((valiForm) => {
        if (!valiForm) {
          this.submitLoading = false;
          return false;
        }

        if (!this.addForm.expectStartRange) {
          this.$message.error("请选择期望到场时间段");
          this.submitLoading = false;
          return
        }

        // 校验拓展表
        console.log(
          "this.deviceIdReportRepair==========>",
          this.deviceIdReportRepair
        );
        let deviceId = "";
        let webCreate = 0;
        if (this.choosenModuleName === "EquipmentMaintenance") {
          deviceId = this.deviceIdReportRepair;
        }
        if (this.moduleTypeKey + "" === "7") {
          webCreate = 0;
        }
        if (this.$refs.addFormExtend) {
          console.log(this.$refs.addFormExtend.addFormExtend);
          this.$refs.addFormExtend.validate().then((valiFormExtend) => {
            if (!(valiForm && valiFormExtend)) {
              this.submitLoading = false;
              return;
            } else {

              if (this.$refs.addFormExtend.addFormExtend.timeRange) {

                if ((this.$refs.addFormExtend.addFormExtend.timeRange[0] + '') === (this.$refs.addFormExtend.addFormExtend.timeRange[1] + '')) {

                  this.$message.error("开始时间和结束时间相同!");
                  this.submitLoading = false;
                  return;
                }
              }
              this.addForm.moduleJson = JSON.stringify({
                deviceId: deviceId,
                ...this.addFormExtend,
                webCreate: webCreate,
              });
              this.addForm.attachList = this.fileList;
              createOrder(this.addForm).then((res) => {
                this.deviceIdReportRepair = "";
                this.dialogOrderCreateBoxVisible = false;

                this.submitLoading = false;
                this.searchChange();
                if (res.success == true) {
                  this.$message.success(res.msg);
                } else {
                  this.$message.error(res.msg);
                }
              }).catch((err) => {
                this.submitLoading = false;
              });
            }
          });

        } else {
          this.addForm.attachList = this.fileList;
          // 无拓展表的情况
          this.addForm.moduleJson = JSON.stringify({
            deviceId: deviceId,
            webCreate: webCreate,
          });
          createOrder(this.addForm).then((res) => {
            this.deviceIdReportRepair = "";
            this.dialogOrderCreateBoxVisible = false;
            this.submitLoading = false;
            this.searchChange();
            if (res.success == true) {
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          }).catch((err) => {
            this.submitLoading = false;
          });;
        }
      });
    },

    editAreaNodeTreeClick_(node) {
      setTimeout(() => {
        console.log(node);
        if (parseInt(node.nodeType) == 1) {
          // this.$message.error();
          return;
        }
        let nodeId = node.id;
        let nodeTitle = node.name;
        // this.addForm.requireMainId = "";
        this.addForm = Object.assign({}, this.addForm, {
          areaName: nodeTitle,
          areaId: nodeId,
        });
        this.$refs.addConnectSelect.blur();
        this.areaNameFlag = true;
        this.areaIdFlag = false;
        getDeptDetailByAreaId({
          areaId: nodeId
        }).then((res) => {
          console.log(res);
          // this.addForm.requireDeptName = res.data.deptName;
          // setTimeout(()=>{
          getDeptUserListByDeptId({
            deptId: res.data.id
          }).then((response) => {
            console.log('getDeptUserListByDeptId', response);
            // this.addForm = Object.assign({}, this.addForm, {
            //   requireMainId: '',
            //   contactName: '',
            // });
            response.data.forEach(element => {
              element.label = element.realNameAndPhone
              element.value = element.id
            })
            setTimeout(() => {
              let hasDefaultMan = false;
              this.requireUserList = response.data;
              this.requireUserList.forEach((ele, index) => {
                if (ele.id === this.addForm.requireMainId) {
                  console.log("ele.id,this.addForm.requireMainId===============>", ele.id, this.addForm.requireMainId);
                  hasDefaultMan = false
                }
              });
              if (this.requireUserList && this.requireUserList.length == 0) {
                hasDefaultMan = true;
              }
              let self = this;
              console.log("hasDefaultMan=============>", hasDefaultMan);
              console.log("requireUserList=============>", this.requireUserList);
              if (hasDefaultMan) {
                this.requireUserList = [{
                  value: self.userInfo.user_id,
                  label: self.userInfo.nick_name,
                  id: self.userInfo.user_id,
                  realNameAndPhone: self.userInfo.nick_name
                }]
                console.log("requireUserList=============>", this.requireUserList);
              }
              this.addForm = Object.assign({}, this.addForm, {
                requireDeptName: res.data.deptName,
              });
              this.addForm = Object.assign({}, this.addForm, {
                deptId: res.data.id,
              });
            });
          });
          //   console.log(this.addForm);
          // })
        });
      }, 0);
    },
    orderSubModuleIdChange(val) {
      // getRemarkList({
      //   projectId: this.addForm.projectId,
      //   moduleType: this.addForm.moduleType,
      //   actionType: 0,
      //   subModuleId: val,
      //   workStatus: 0,
      // }).then((res) => {
      //   console.log(res);
      //   this.remarkAddFormList = res.data;
      //   this.$refs.addFormRemarkModel.setRemarkList(this.remarkAddFormList);
      // });
    },


    //获取字段填写修饰
    async getFieldDetail(projectId, moduleType, actionType) {
      console.log("执行了")
      let obj = {
        projectId: projectId,
        moduleType: moduleType,
        actionType: actionType
      }
      await fieldDetail(obj).then(res => {
        let description, uploadFile
        res.data.forEach(item => {
          if (item.fieldCode == "uploadFile") {
            uploadFile = item
          }
          if (item.fieldCode == "description") {
            description = item
          }

        })
        if (description) {
          if (description.defaultMustFlag == 0) {
            // this.addFormRules['description'][0].required = false
          } else {
            // this.addFormRules['description'][0].required = true
          }
        }
        if (uploadFile) {
          if (uploadFile.defaultMustFlag == 0) {
            this.formImgRequireFlag = false
          } else {
            this.formImgRequireFlag = true
          }
        }

      })
    },
    // 服务类型切換
    orderModuleTpyeChange(val) {
      let projectId = this.deepClone(this.addForm.projectId);
      let source = this.deepClone(this.addForm.source);
      let moduleType = this.deepClone(this.addForm.moduleType);
      let urgentLevel = this.deepClone(this.addForm.urgentLevel);
      let self = this;
      this.remainUserList = [];
      this.deptList_ = [];
      this.addForm = {
        projectId: projectId,
        source: source,
        moduleType: moduleType,
        dropInFee:0,
        urgentLevel:self.urgentLevelList[0].dictKey,
      }
      if (!this.addForm.projectId) {
        this.$message.error("请先选择项目!");
        return;
      }
      if (val == 7) {
        this.getFieldDetail(this.addForm.projectId, val, 0)
      } else {
        // this.addFormRules['description'][0].required = true
        this.formImgRequireFlag = false
      }

      console.log(val)
      this.addForm = Object.assign({}, this.addForm, {
        subModuleId: ''
      });
      console.log("this.addForm.moduleTye:=>", this.addForm.moduleType);

      // getRemarkList({
      //   projectId: this.addForm.projectId,
      //   moduleType: val,
      //   actionType: 0,
      //   workStatus: 0,
      // }).then((res) => {
      //   console.log(res);
      //   this.remarkAddFormList = res.data;
      //   this.$refs.addFormRemarkModel.setRemarkList(this.remarkAddFormList);
      // });

      getServiceItemList({
        moduleType: this.addForm.moduleType,
        projectId: this.addForm.projectId,
      }).then((res) => {
        // this.subModuleList = res.data;

        // this.subModuleList = this.deepClone(this.subModuleList);

        this.subModuleList = Object.assign({}, {}, res.data);
        this.subModuleList = this.deepClone(this.subModuleList);
        console.log('this.subModuleList==========>', this.subModuleList);
        this.addForm = Object.assign({}, this.addForm, {});

        this.contactNameList;

        console.log(res);
      });
      // 动态组件 val:1 ===> this.choosenModuleName:'Clean'
      this.moduleTypeKey = val;
      this.choosenModuleName = modulesConfig[val];
      console.log("this.choosenModuleName==========>", this.choosenModuleName);
      this.addFormExtend = {};
      // 查询是否需要经纬度
      // settingPositionflag({
      //   projectId: this.addForm.projectId,
      //   moduleType: this.addForm.moduleType,
      // }).then((res) => {
      //   this.positionFlag = res.data;
      //   let positionLongitude = this.findObject(this.addOrderFormOption.column, 'positionLongitude')
      //   let positionLatitude = this.findObject(this.addOrderFormOption.column, 'positionLatitude')
      //   if (this.positionFlag) {
      //     positionLongitude.display = true;
      //     positionLatitude.display = true;
      //   } else {
      //     positionLongitude.display = false;
      //     positionLatitude.display = false;
      //   }
      // });
      // 重置 期望到场时间
      this.dateSelected = false
    },
    // 切换 项目
    changeHandler_(value) {
      this.projectId = value;
      // getRemarkList({projectId:value, actionType:0}).then((res)=>{
      //   console.log(res);
      //   this.remarkAddFormList = res.data;

      //         this.$refs.addFormRemarkModel.setRemarkList(this.remarkAddFormList);
      // });

      // 清空服务类型
      // 清空区域 区域暂时未和项目挂钩,下面不再拉取区域数据
      this.addForm = Object.assign({}, this.addForm, {
        areaId: "",
        areaName: "",
        moduleType: "",
        subModuleId: "",
        communityId:'',
        contactName:'',
        contactPhone:'',
        contactAddress:'',
        serviceItemId:'',dropInFee:0
      });
      this.subModuleList = [];
      this.moduleTypeList = [];
      // 是否需要经纬度
      this.positionFlag = false;
      // 动态获取服务类型
      modulesSetting(value).then((res) => {
        if (res.success) {
          this.moduleTypeList = res.data;
        }
      });
      this.communityList = [];
      // this.addForm.communityId = '';
      // this.add
      getServiceCommunityList({projectId:value}).then((res) => {
        this.communityList = res.data;
      })
      lazyTree({
        parentId: 0,
        projectId: value
      }).then(({
        data
      }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        this.treeFormAreaData = data;
      });
    },

    addOrderHandler() {
      this.projectId = this.searchform.projectId;
      this.addForm = {dropInFee:0};
      this.addForm.projectId = this.searchform.projectId;
      this.fileList = [];
      this.addFormExtend = {};
      this.choosenTypeId = "";
      this.choosenModuleName = "";
      this.remainUserList = [];
      // 需求来源
      if (this.deviceIdReportRepair) {
        this.addForm.moduleJson = {
          deviceId: this.deviceIdReportRepair,
        };
      }
      this.subModuleList = [];
      this.dialogOrderCreateBoxVisible = true;
      // 动态获取服务类型
      modulesSetting(this.projectId).then((res) => {
        if (res.success) {
          this.moduleTypeList = res.data;
        }
      });
      getDictionary({
        code: "order_require_source"
      }).then((res) => {
        this.orderRequireSourceList = [];
        res.data.forEach((ele, index) => {
          if (ele.dictValue === "电话" || ele.dictValue === "现场" || ele.dictValue === "运营调度中心") {
            this.orderRequireSourceList.push(ele);
          }
        });
        getOrderUrgentLevel().then((res) => {
          console.log(res);
          this.urgentLevelList = res.data;

          this.addForm.urgentLevel = this.urgentLevelList[0].dictKey;

          // getUserListByDepartmentId({}).then((res) => {
          //   console.log('getUserListByDepartmentId', res);
          //   //人员选择
          //   res.data.forEach(item => {
          //     item.label = item.realNameAndPhone
          //     item.value = item.id
          //   })
          //   this.requireUserList = res.data;
          let self = this;
          this.requireUserList = [{
            value: self.userInfo.user_id,
            label: self.userInfo.nick_name,
            id: self.userInfo.user_id,
            realNameAndPhone: self.userInfo.nick_name
          }]
          setTimeout(() => {
            this.requireUserList.forEach((ele, index) => {
              if (ele.id === this.userInfo.user_id) {
                this.addForm.requireMainId = this.userInfo.user_id;
                this.addForm = Object.assign({}, this.addForm, {
                  requireMainId: this.userInfo.user_id,
                  contactName: ele.realName,
                });
              }
            });
          });
          this.addForm.dropInFee = 0;
          console.log(this.userInfo.user_id);
          // });
        });
      });
    },

    addReportRepair(val) {
      console.log(val);
      this.deviceIdReportRepair = val;
      // this.addForm.moduleJson = {
      //   deviceId:val
      // };
      this.addOrderHandler();
    },

    workStatusChange(val) {
      this.searchChange();
      console.log("workStatusChange()=========>", val);
    },
    orderAngleChange(val) {
      this.searchChange();
      console.log("workStatusChange()=========>", val);
    },
    moduleTypeChange(val) {
      console.log(val);
      if (!val) {
        this.subModuleList = [];
        this.searchChange();
        return;
      }
      getServiceItemList({
        moduleType: val,
        projectId: this.searchform.projectId,
      }).then((res) => {
        // this.subModuleList = res.data;

        // this.subModuleList = this.deepClone(this.subModuleList);

        this.subModuleList = Object.assign({}, {}, res.data);
        this.subModuleList = this.deepClone(this.subModuleList);
        // console.log('this.subModuleList==========>', this.subModuleList);
        // this.addForm = Object.assign({}, this.addForm, {});

        // this.contactNameList;

        // console.log(res);
      });
      this.searchChange();
    },
    subModuleTypeChange(val) {
      console.log(val);
      this.searchChange();
    },
    sortChange(val) {
      console.log(val);
      if (val.order === "ascending") {
        this.searchform = Object.assign({}, this.searchform, {
          orderSort: 5
        });
        this.searchChange();
      } else {
        this.searchform = Object.assign({}, this.searchform, {
          orderSort: ''
        });
        this.searchChange();
      }
    },
    advanceSearch() {
      this.advanceSearchFlag = !this.advanceSearchFlag;
      console.log(this.searchform)
      getProviderList({projectId:this.projectId,status:1}).then(res=>{
        this.serviceProviderIdList = res.data;
      })
      this.$nextTick(() => {
        console.log(this.$refs.crud.$refs.table.$el.offsetTop);
        this.$refs.crud.getTableHeight();
      });
    },
    clear() {
      this.searchform.areaId = "";
      this.searchform.areaName = "";
      // this.$refs.tree.setChecked(this.treeNodeId,false,false)
    },
    // 树加载完毕
    editAreaLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      lazyAreaTree({
        parentId: id,
        projectId: this.projectId
      }).then(
        ({
          data
        }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
            });
          } else {}
          resolve(data);
        }
      );
    },
    editAreaNodeTreeClick(node) {
      console.log("click");
      setTimeout(() => {
        let nodeId = node.id;
        this.treeNodeId = node.id;
        let nodeTitle = node.name;
        getDeptDetailByAreaId({
          id: nodeId
        }).then((res) => {
          console.log(res);
          this.searchform.deptName = res.data.deptName;
          this.searchform = Object.assign({}, this.searchform, {
            deptName: res.data.deptName,
          });

          getDeptUserListByDeptId({
            deptId: res.data.id
          }).then((res) => {
            if (res.data && res.data.length > 0) {
              this.contactNameList = res.data;
            }
          });
        });
        this.searchform = Object.assign({}, this.searchform, {
          areaName: nodeTitle,
          areaId: nodeId,
        });
        this.$refs.connectSelect.blur();
        this.areaNameFlag = true;
        this.areaIdFlag = false;
      }, 0);
    },
    changeHandler(value) {
      this.serviceProviderIdList = [];
getProviderList({projectId:value,status:1}).then(res=>{
  this.serviceProviderIdList = res.data;
})
this.communityList = [];
this.addForm.communityId = '';
this.addForm.contactName = '';
this.addForm.contactPhone = '';
this.addForm.contactAddress = '';
this.addForm.serviceItemId = '';

getServiceCommunityList({projectId:value}).then((res) => {
  this.communityList = res.data;
})
      // 动态获取服务类型
      modulesSetting(value).then((res) => {
        if (res.success) {
          this.moduleTypeList_ = res.data;
        }
      });
      // 动态获取部门部门
      this.getSearchDeptTreeByIdsAndProjectId(value);
      // out_order_work_status 获取工单状态
      getDictData("order_List_work_status").then((res_) => {
        this.workStatusDict = res_.data;
        this.workStatusDict = [{
          dictKey:'0',
          dictValue:'待预付'
        },{
          dictKey:'1',
          dictValue:'待指派'
        },{
          dictKey:'2',
          dictValue:'已指派'
        },{
          dictKey:'3',
          dictValue:'待上门'
        },{
          dictKey:'4',
          dictValue:'进行中'
        },{
          dictKey:'5',
          dictValue:'已完成'
        },{
          dictKey:'6',
          dictValue:'已评价'
        },{
          dictKey:'7',
          dictValue:'已回访'
        },{
          dictKey:'8',
          dictValue:'已取消'
        },{
          dictKey:'sum',
          dictValue:'全部'
        }]
        this.getOrderWorkStatusSum();
      });
      lazyAreaTree({
        parentId: 0,
        projectId: value
      }).then(({
        data
      }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        this.searchform.areaName = "";
        this.searchform.areaId = "";
        this.treeFormAreaData = data;
      });
    },
    /* 获取工单状态数据 */
    getOrderWorkStatusSum() {
      getOrderWorkStatusSum({
        projectId: this.searchform.projectId,
      }).then((response) => {
        let countList = [];
        let arr = this.deepClone(this.workStatusDict);
        let _workStatusList_ = this.listSortFunc(arr);
        for (var key in response.data) {
          console.log(key);
          console.log(response.data[key]);
          countList.push({
            key: key,
            val: response.data[key],
          });
        }
        countList.forEach((ele, index) => {
          if (ele.key === 'sum') {
            _workStatusList_[index] = {
              dictKey: '',
              dictValue: '全部',
              count: ele.val,
            };
          } else {
            _workStatusList_[index] = {
              dictKey: _workStatusList_[index].dictKey,
              dictValue: _workStatusList_[index].dictValue,
              count: ele.val,
            };
          }
        });
        this.workStatusList_ = _workStatusList_;
      });
    },
    // 打开历程弹窗
    openCourse(row, type) {
      this.crudLoading = true;

      this.courseRepairFlag = true;
      setTimeout(() => {

        this.$refs.courseRepair.getDictionary(row).then(() => {
          if (type == "edit") {
            this.$refs.courseRepair.openDialog(row, true);
          } else {
            this.$refs.courseRepair.openDialog(row, false);
          }


          this.crudLoading = false;
        });
      });
      return;
      switch (parseInt(row.moduleType)) {
        case 1:
          this.courseCleanKeepingFlag = true;
          setTimeout(() => {
            this.$refs.courseCleanKeeping.getDictionary().then(() => {

              this.$refs.courseCleanKeeping.openDialog(row);

              this.crudLoading = false;
            })
          })
          break;
        case 2:


          this.courseSecurityFlag = true;
          setTimeout(() => {

            this.$refs.courseSecurity.getDictionary().then(() => {

              this.$refs.courseSecurity.openDialog(row);

              this.crudLoading = false;
            });
          });
          break;
        case 3:

          this.courseEscortFlag = true;
          setTimeout(() => {

            this.$refs.courseEscort.getDictionary().then(() => {
              this.$refs.courseEscort.openDialog(row);

              this.crudLoading = false;
            });
          });
          break;
        case 4:
          this.courseTransportFlag = true;
          setTimeout(() => {

            this.$refs.courseTransport.getDictionary().then(() => {
              this.$refs.courseTransport.openDialog(row);

              this.crudLoading = false;
            });
          });
          break;
        case 5:
          this.courseComplaintsFlag = true;
          setTimeout(() => {

            this.$refs.courseComplaints.getDictionary().then(() => {
              this.$refs.courseComplaints.openDialog(row);

              this.crudLoading = false;
            });
          });
          break;
        case 6:
          this.courseUsecarFlag = true;
          setTimeout(() => {

            this.$refs.courseUsecar.getDictionary().then(() => {
              this.$refs.courseUsecar.openDialog(row);

              this.crudLoading = false;
            });
          });
          break;
        case 7:
          this.courseRepairFlag = true;
          setTimeout(() => {

            this.$refs.courseRepair.getDictionary(row).then(() => {
              if (type == "edit") {
                this.$refs.courseRepair.openDialog(row, true);
              } else {
                this.$refs.courseRepair.openDialog(row, false);
              }


              this.crudLoading = false;
            });
          });
          break;
        case 8:
          this.courseEquipmentMaintenanceFlag = true;
          setTimeout(() => {

            this.$refs.courseEquipmentMaintenance.getDictionary().then(() => {
              this.$refs.courseEquipmentMaintenance.openDialog(row);

              this.crudLoading = false;
            });
          });
          break;
        case 9:
          this.courseEquipmentInspectionFlag = true;
          setTimeout(() => {

            this.$refs.courseEquipmentInspection.getDictionary().then(() => {
              this.$refs.courseEquipmentInspection.openDialog(row);

              this.crudLoading = false;
            });
          });
          break;
        case 10:
          this.courseAreaInspectionFlag = true;
          setTimeout(() => {

            this.$refs.courseAreaInspection.getDictionary().then(() => {
              this.$refs.courseAreaInspection.openDialog(row.id);

              this.crudLoading = false;
            });
          });
          break;
        case 11:
          this.courseComprehensiveInspectionFlag = true;
          setTimeout(() => {

            this.$refs.courseComprehensiveInspection.getDictionary().then(() => {
              let obj = Object.assign({}, row)
              obj.orderId = row.id
              this.$refs.courseComprehensiveInspection.openDialog(obj);

              this.crudLoading = false;
            });
          });
          break;
        case 12:
          this.courseRepairInformationFlag = true;
          setTimeout(() => {

            this.$refs.courseRepairInformation.getDictionary().then(() => {
              if (type == "edit") {
                this.$refs.courseRepairInformation.openDialog(row, true);
              } else {
                this.$refs.courseRepairInformation.openDialog(row, false);
              }

              this.crudLoading = false;
            });
          });
          break;
        case 13:
          this.courseRepairLogisticsFlag = true;
          setTimeout(() => {

            this.$refs.courseRepairLogistics.getDictionary().then(() => {
              if (type == "edit") {
                this.$refs.courseRepairLogistics.openDialog(row, true);
              } else {
                this.$refs.courseRepairLogistics.openDialog(row, false);
              }

              this.crudLoading = false;
            });
          });
          break;
      }
    },
    listSortFunc(list) {
      let arr = list;

      arr.sort((a, b) => {
        return a.sort - b.sort
      });
      console.log("listSortFunc=====>", arr);
      return arr
    },
    getDictionaryData() {
      //加载列表
      getprojectList({}).then((res) => {
        this.projectIdList = res.data;
        if (this.projectIdList.length > 0) {
          this.query.projectId = this.projectIdList[0].id;
          this.searchform.projectId = this.projectIdList[0].id
          this.getSearchDeptTreeByIdsAndProjectId(this.query.projectId);

    getServiceCommunityList({projectId:this.query.projectId}).then((res) => {
      this.communityList = res.data;
    })
        }

        if (this.$route.query.id) {
          setTimeout(() => {
            this.onLoad_();
          });
        } else {
          setTimeout(() => {

            this.onLoad();
          });
        }
        // this.$nextTick(() => {
        //   this.reWrite = true;
        // });


        getDictData("return_visit_satisfaction").then((res) => {
          this.satisfactionList = res.data;
          console.log("getDictionaryData()===========>");
        });
        getDictData("order_require_source").then((res) => {
          this.orderRequireSourceList = res.data;
          console.log("getDictionaryData()===========>");
        });
        getDictData("car_use_type").then((res) => {
          this.useTypeList = res.data;
          console.log("getDictionaryData()===========>");
        });

        // out_order_work_status 获取工单状态
        getDictData("out_order_work_status").then((res) => {
          this.workStatusList = res.data;
        });

        // out_order_work_status 获取工单状态
        getDictData("order_List_work_status").then((res_) => {
          this.workStatusDict = res_.data;
        this.workStatusDict = [{
          dictKey:'0',
          dictValue:'待预付'
        },{
          dictKey:'1',
          dictValue:'待指派'
        },{
          dictKey:'2',
          dictValue:'已指派'
        },{
          dictKey:'3',
          dictValue:'待上门'
        },{
          dictKey:'4',
          dictValue:'进行中'
        },{
          dictKey:'5',
          dictValue:'已完成'
        },{
          dictKey:'6',
          dictValue:'已评价'
        },{
          dictKey:'7',
          dictValue:'已回访'
        },{
          dictKey:'8',
          dictValue:'已取消'
        },{
          dictKey:'sum',
          dictValue:'全部'
        }]
          this.getOrderWorkStatusSum();
        });
        // out_order_work_status 获取工单状态
        getDictData("order_List_orderAngle").then((res) => {
          this.orderAngleList = res.data;
        });

        // out_order_work_status 获取工单状态

        // 动态获取服务类型
        modulesSetting(this.projectIdList[0].id).then((res) => {
          if (res.success) {
            this.moduleTypeList_ = res.data;
          }
        });
        // 紧急程度 order_urgent_level   out_order_work_status
        getDictData("order_urgent_level").then((res) => {
          this.urgentLevelList = res.data;
        });

        // 通用标识 common_flag
        getDictData("common_flag").then((res) => {
          this.approveFlagList = res.data;
          this.timeoutFlagList = res.data;
        });
        //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
        this.firstDisplayFlag = true;
      });
    },

    searchReset(...a) {
      let projectId = this.query.projectId;
      let emptyForm = {
        projectId: this.query.projectId
      };
      this.searchform = this.deepClone(emptyForm);
      this.query = {
        projectId: projectId
      };
      this.searchform.description =''
      setTimeout(() => {
        this.searchform = this.deepClone(emptyForm);
        this.onLoad();
      });
    },
    searchChange(params, done) {
      this.advanceSearchFlag = false
      this.query = Object.assign({}, this.searchform, params);
      this.page.currentPage = 1;
      this.onLoad();
    },
    // selectionChange(list) {
    //   this.selectionList = list;
    // },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    // 选择时间段
    timeRangeChange(e) {
      this.addForm.expectStartTime = this.addForm.expectStartDate + ' ' + this.addForm.expectStartRange
      console.log('expectStartTime', this.addForm.expectStartTime);
    },
    // 获取当天时间段
    setTodayTime(startHour, startMinute) {
      let items = []
      // 判断时间段是否有效
      const len = this.timeRangeList.length;
      if (len) {
        for (let i = 0; i < len; i++) {
          let tR = this.timeRangeList[i];
          const arr = tR.text.split("-");
          // 获取时间段左边的数值
          const t1 = arr[0];
          const tArr = t1.split(":");
          // 获取 小时数
          let tH = tArr[0].trim();
          // 获取 分钟数
          let tM = tArr[1].trim();
          // 去除前面的0
          tH = tH.replace(/^0+/, "");
          tM = tM.replace(/^0+/, "");
          tR.id = i
          // 当前时间 小时数 < tH 或者 小时数 == tH, 分钟数 < tM
          if (Number(startHour) < Number(tH) || (Number(startHour) == Number(tH) && Number(startMinute) < Number(tM)))  {
            items.push(tR)
          }
        }
      }
      this.activeTimeRange = items
    },
    // 设置时间
    setTimeRange(e) {
      // 获取当前时间
      const now = this.dayjs()
      // 选择的日期
      const date2 = this.dayjs(e)
      // 是否是当天
      const isToday = now.isSame(date2, 'day')
      console.log('isToday-----', isToday)
      const startHour = now.hour();
      const startMinute = now.minute();
      if (isToday) {
        this.setTodayTime(startHour, startMinute)
      } else {
        this.activeTimeRange = this.timeRangeList.map((item, i) => {
          item.id = i
          return item
        })
      }
      // 第一个默认选中
      if (this.activeTimeRange.length > 0 && !this.addForm.expectStartRange) {
        this.addForm.expectStartRange = this.activeTimeRange[0].text
        this.timeRangeChange()
      }
    },
    pickDate(e) {
      console.log('pickDate----', e);
      this.activeTimeRange = []
      this.addForm = Object.assign({}, this.addForm, {
        expectStartRange: '',
      })
      this.setTimeRange(e)
      this.dateSelected = true
    },
    onLoad_(page) {
      page = page || this.page;

      this.exportForm = JSON.parse(JSON.stringify(this.$route.query));
      if(this.$route.query.projectId!=''){
        console.log('onLoad_');
        this.loading = true;
        getList(this.$route.query)
        .then(({
          data
        }) => {
          this.query.projectId = this.$route.query.projectId;

          this.searchform = Object.assign({}, this.searchform, {
            projectId: this.$route.query.projectId
          });
          this.changeHandler(this.searchform.projectId)
          // if (this.firstDisplayFlag) {


          //   this.firstDisplayFlag = false;
          //   console.log("this.searchform.projectId======>", this.searchform.projectId);
          // }

          this.page.total = data.total;
          this.page.currentPage = data.current;

          this.data = data.records;
          console.log('_data',this.data);
          this.loading = false;
          this.selectionClear();
          this.data.forEach(ele=>{
            ele.moduleType = ele.moduleType+'';
            ele.source = ele.source+'';
            ele.satisfaction = ele.satisfaction+'';
          });
        })
        .catch((err) => {
          this.loading = false;
        });

      }

    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      this.exportForm = JSON.parse(JSON.stringify(this.query));
      if(this.searchform.projectId!=''){
        this.getOrderWorkStatusSum(); // 每次刷新分页数据时都同步更新下状态数据，因为工单随时都有可能发生变化，比如小程序端增删了工单等
        getList(
          Object.assign({
              current: page.currentPage,
              size: page.pageSize
            },
            this.searchform
          )
        )
        .then(({
          data
        }) => {

          console.log('data',data);
          this.page.total = data.total;
          this.page.currentPage = data.current;

          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          this.data.forEach(ele=>{
            ele.moduleType = ele.moduleType+'';
            ele.source = ele.source+'';
            ele.satisfaction = ele.satisfaction+'';
          });
        })
        .catch((err) => {
          this.loading = false;
        });
      }

    },
  },
};

export default mixin
